(function() {
    'use strict';
    angular
        .module('gwApp')
        .factory('Makeup', Makeup);

    Makeup.$inject = ['$resource'];

    function Makeup ($resource) {
        var resourceUrl =  'api/makeups/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true,
                params: {
                    id: 'pages'
                },
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getAll': {
                method:'GET',
                isArray: true,
                params: {
                    path: 'getAll'
                }
            } ,
            'delete':{
                method:'DELETE',
                params: {
                    login: 'id'
                }
            },
            'add': { method:'POST' } ,
            'update': { method:'PUT' },
            'detail': {method:'GET',
                params:{
                    id:'exists'
                }
            }
        });
    }

})();
